<template>
    <div :data-qa="`card_${title}`.replace(/\s+/g, '')">
        <div class="mx-auto w-full desktop:max-w-sm shadow-xl relative bg-white flex flex-col items-stretch h-full rounded-lg"
            :class="[bannerStyles]">
            <!-- most popular banner -->
            <div v-if="banner"
                data-qa="card_banner_text"
                class="w-full transform rounded-t-md pt-2 pb-2 text-center uppercase text-base font-bold text-navy-dark"
                :class="bannerStyles"
                v-html="promoBannerText"
            >
            </div>

            <!-- the actual offer card -->
            <div class="flex flex-col px-3 pt-3 pb-6 border-4 border-white bg-white rounded-xl h-full items-stretch"
                :class="bannerBorderHelper">
                <div class="pb-3">
                    <div>
                        <InternetSpeedGauge :speed="speed.download"
                                            :upload="speed.upload"
                                            :idealFor="idealFor"/>
                    </div>
                    <div class="text-sm font-bold leading-5 bg-gray-300 text-navy-dark rounded mt-4">
                        <div class="bg-blue-light rounded h-2 "
                            :class="{
                                100: 'w-1/4',
                                200: 'w-2/4',
                                250: 'w-3/4',
                                500: 'w-3/4',
                                1000: 'w-full',
                            }[speed.download] || ''"
                        ></div>
                    </div>
                </div>
                <div class="py-4 flex flex-row justify-between items-start">
                    <div class="text-sm leading-5 self-start">
                        <h2 data-qa="card_product_title" class="widescreen:text-xl font-bold text-navy-dark mb-0.5 offer-card-name leading-6 text-lg">
                            {{ title }}
                        </h2>

                        <div v-if="pricingDetails !== null && pricingDetails.hasOwnProperty('cards') && pricingDetails.cards.length">
                            <InfoModal
                                :product-title="title"
                                :full-price="fullPrice"
                                :promo-price="promoPrice"
                                :promo-months="promoMonths.split(',')[0]"
                                :promo-link="promoLink"
                                :promo-label="promoLabel"
                                :pricing-details="pricingDetails"
                                :secondary-promo-months="secondaryPromoMonths"
                            />
                        </div>
                        <a v-else
                            :href="link" target="_blank" class="font-normal text-left text-navy-dark underline">
                            <span id="product_card_pricing_details_link">{{label}}</span>
                        </a>
                    </div>
                    <div>
                        <!-- <div v-if="previousPrice" class="onSalePrice mb-6 relative">
                            <PrevPricePerMonth
                                :price="previousPrice"
                            />
                        </div> -->
                        <div class="relative">
                            <PricePerMonth
                                :price="promoPrice"
                                :full-price="fullPrice"/>
                        </div>
                    </div>
                </div>
                <div id="promoBanner" v-if="promoBanner" class="pt-3 pb-3 space-y-1">
                    <div v-for="(sentence, index) in adjustPromoBanner" :key="index"
                        class="text-navy-dark rounded-md text-sm font-heavy text-center flex justify-center items-center py-2 pr-5 tablet:pr-2 widescreen:pr-5 pl-2">
                    <img src="/assets/icons/positive_resi_icon.png" class="w-5 h-5" alt="Plus Symbol">
                    <p class="ml-4 tablet:ml-2 widescreen:ml-4 text-left uppercase">{{ sentence }}</p>
                    </div>
                </div>
                <div v-if="showButton"
                    class="pt-4 mt-auto">
                    <div class="flex desktop:flex-col-reverse justify-center lg:justify-between items-center gap-4">
                        <div class="relative">
                            <button
                                data-qa="card_product_button"
                                @click.prevent="$emit('select')"
                                data-category="resi: order button"
                                :data-action="`${title} product box`"
                                :data-label="`resi: ${url} ${title} button`"
                                type="button"
                                class="track btn-primary-sm offer-card-select"
                                data-cy="offer-button">
                                Select Plan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="gradientCallout && gradientCallout.text && gradientCallout.color"
             class="py-6 px-1.5 text-center text-white rounded-b-lg"
            :class="gradientCallout.color + (banner? '': '')">
            <div class="flex items-center justify-center">
                <IconCircleDollar class="flex-shrink-0 w-5 h-5 mr-1.5" />
                <span class="text-sm font-bold" v-html="gradientCallout.text" />
            </div>
        </div>
    </div>
</template>

<script>
    import InternetSpeedGauge from '@/atoms/InternetSpeedGauge'
    import PricePerMonth from '@/atoms/PricePerMonth'
    import PrevPricePerMonth from '@/atoms/PrevPricePerMonth'
    import IconChevronDown from "@/atoms/icons/IconChevronDown"
    import InfoModal from '@/molecules/InfoModal'
	import IconCircleDollar from "../../atoms/icons/IconCircleDollar.vue"
    import { mapState } from "vuex";
    export default {
        name: 'OfferCard',
        components: {
			IconCircleDollar,
            InternetSpeedGauge,
            PricePerMonth,
            PrevPricePerMonth,
            IconChevronDown,
            InfoModal
        },
        props: {
            title: {
                type: String,
                default: null,
            },
            banner: {
                type: Object,
                default: null,
            },
            pricingDetails: {
                type: Object,
                default: null,
            },
            promoPrice: {
                type: Number,
                default: 99,
            },
            promoMonths: {
                type: String,
                default: "12",
            },
            previousPrice : {
                type: Number,
            },
            promoLink: {
                type: String,
                default: null,
            },
            promoLabel: {
                type: String,
                default: null,
            },
            fullPrice: {
                type: Number,
                default: 999,
            },
            download: {
                type: String,
                default: "1000",
            },
            upload: {
                type: String,
                default: null,
            },
            idealFor: {
                type: String,
                default: null,
            },
            promoBanner: {
                type: String,
                default: null
            },
            showButton: {
                type: Boolean,
                default: true,
            },
            wywCard: {
                type: Boolean,
                default: false,
            },
            gradientCallout: {
			    type: Object,
                default: null
            },
        },
        computed: {
            ...mapState({
                meta: state => state.meta,
                isAbandonedCart: state => state.meta.isAbandonedCart,
                activePromotions: state => state.Promotions.activePromotions
            }),
            promoBannerText() {
                // If no banner exists, return empty string
                if (!this.banner) return '';

                //check if url contains tv or phone
                let url = window.location.pathname
                if(url.includes('tv') || url.includes('phone')) return this.banner.text || '';

                // Get current product download speed
                const downloadSpeed = this.speed.download;

                // Check if active promotions can be applied
                if (this.activePromotions && this.activePromotions.length) {
                    // Find promotions with products matching our speed
                    const matchingPromotions = this.activePromotions.filter(promo => 
                    promo.products && promo.products.some(product => product.speed === downloadSpeed)
                    );
                    
                    // Sort by weight (higher weight is higher priority)
                    const sortedPromotions = matchingPromotions.sort((a, b) => (b.weight || 0) - (a.weight || 0));
                    
                    // Find highest priority promotion
                    if (sortedPromotions.length > 0) {
                    const topPromotion = sortedPromotions[0];
                    
                    // Find the product that matches our speed
                    const product = topPromotion.products.find(p => p.speed === downloadSpeed);
                        if (product && product.ui_elements) {
                            // Find the package_header UI element
                            const packageHeader = product.ui_elements.find(ui => ui.key === "package_header");
                            
                            if (packageHeader && packageHeader.text) {
                                return packageHeader.text;
                            }
                        }
                    }
                }

                // Default: return the original banner text
                return this.banner.text || '';
            },
            url() {
                return window.location.href
            },
            speed() {
                const download = this.download?.split(',') ?? [0]
                const upload = this.upload?.split(',') ?? [0]
                return {
                    previousDownload: download.length > 1? parseInt(download[0]): 0,
                    previousUpload: upload.length > 1? parseInt(upload[0]): 0,
                    download: download.length > 1? parseInt(download[1]): parseInt(download[0])?? 0,
                    upload: upload.length > 1? parseInt(upload[1]): parseInt(upload[0])?? 0,
                }
            },
            bannerStyles() {
                return this.banner ? ({
                    yellow: 'bg-yellow-400 text-black',
                    teal:   'bg-teal text-white desktop:-mt-4',
                    salmon: 'bg-salmon text-white desktop:-mt-4',
                    blue:   'bg-blue-light text-white desktop:-mt-4',
                    gray:   'bg-gray-200 text-navy desktop:-mt-4'
                })[this.banner? this.banner.color: ''] : ''
            },
            bannerBorderHelper() {
                return this.banner ? ({
                    teal: `border-teal`,
                    blue: `border-blue-light`,
                    yellow: `border-yellow-400`,
                    salmon: `border-salmon border-t-0`,
                    gray: `border-gray-200`,
                })[this.banner? this.banner.color: ''] : ''
            },
            secondaryPromoMonths() {
                const promoMonths = this.promoMonths.split(',')
                if (promoMonths.length > 1) {
                    return promoMonths[1]
                }

                const variant = this.variants?.find(variant => variant.promoMonths)

                return variant?.promoMonths || promoMonths[0]
            },
            link() {
                return this.pricingDetails?.url || this.promoLink
            },
            label() {
                return this.pricingDetails?.label || 'Pricing Details'
            },

        adjustPromoBanner() {
            if (!this.promoBanner) return null;
      
            const sentences = this.promoBanner
                .split('.')
                .map(sentence => sentence.trim())
                .filter(sentence => sentence.length > 0);
            
            if (sentences.length > 1) {
                return [
                sentences[0],
                sentences.slice(1).join(' ')
                ];
            } else {
                return [sentences[0]];
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .pulsating-block::after {
        content: '';

        @apply block
               absolute
               top-0
               left-0
               w-full
               h-full
               bg-gray-300
               text-gray-300
               animate-pulse;
    }
</style>
